const uploadActionTypes = {
  SET_UPLOAD_MENU: 'SET_UPLOAD_MENU',
  UPDATE_PROGRESS: 'UPDATE_PROGRESS',
  CLEAR_QUE: 'CLEAR_QUE',
};
export default uploadActionTypes;
